'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _base = require('base62');

var _base2 = _interopRequireDefault(_base);

var _padLeft = require('./padLeft');

var _padLeft2 = _interopRequireDefault(_padLeft);

var _uidConstants = require('./uidConstants');

var _timestamp = require('./timestamp');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (clientId, clientIdTick) {
    var timestamp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Date().getTime();

    var time = (0, _timestamp.createTimestamp)(timestamp);
    var tick = _base2.default.encode(clientIdTick % _uidConstants.TICK_MAX);
    return time + clientId + (0, _padLeft2.default)(tick, '00');
};


//////////////////
// WEBPACK FOOTER
// ./src/common/uid/createElementId.js
// module id = 2287
// module chunks = 0